/* tslint:disable */
import {
  Sector
} from '../index';

declare var Object: any;
export interface SectorTypeInterface {
  "name": string;
  "id"?: number;
  "sector_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  sector?: Sector;
}

export class SectorType implements SectorTypeInterface {
  "name": string;
  "id": number;
  "sector_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  sector: Sector;
  constructor(data?: SectorTypeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SectorType`.
   */
  public static getModelName() {
    return "SectorType";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SectorType for dynamic purposes.
  **/
  public static factory(data: SectorTypeInterface): SectorType{
    return new SectorType(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SectorType',
      plural: 'SectorTypes',
      path: 'SectorTypes',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "sector_id": {
          name: 'sector_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        sector: {
          name: 'sector',
          type: 'Sector',
          model: 'Sector'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/SectorType.ts